import { FC } from 'react'
import './index.less'
import { ValidationErrorsData } from '../../../shared/graphqlErrorHelper'

interface Props {
  errors: ValidationErrorsData[] | null
  messageOnly?: boolean
}

export const ValidationErrors: FC<Props> = ({ errors, messageOnly }) => (
  <ul className="validation-errors" data-e2e-validation-errors>
    {errors && errors.map((err, index) => <li key={index}>{messageOnly ? err.message : `${err.field}: ${err.message}`}</li>)}
  </ul>
)
